import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { LocationContextPanelComponent } from './location-context-panel/location-context-panel.component';

@NgModule({
    declarations: [LocationContextPanelComponent],
    imports: [CommonModule, MaterialModule, RouterModule],
    exports: [LocationContextPanelComponent]
})
export class LocationContextPanelModule {}
